import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { PostDocDDJJ, PostDocDDJJNuevo } from '../../../actions';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import patologias from './patologias'


const DdjjMedicoNuevo = () => {

  const dispatch = useDispatch()
  const {userId} = useParams()
  const navigate = useNavigate();
  const token = localStorage.getItem('token')
  const [inputDoc, setInputDoc] = useState({
    historiaClinica: '',
    arritmiaAngor: 'no',
    saludMental: 'no',
    saludMentalEspecificar: '',
    alergia: 'no',
    embarazo: 'no',
    maquinaria: 'no',
    diagnostico: '',
    tratamiento: '',
    fechaDelDia: ''
  })


  const [tratamientos,setTratamientos] = useState("")
  useEffect(() => {
    const t = patologias.find(f=>f.nombre===inputDoc.diagnostico)?.tratamiento  
    setTratamientos(t)
  }, [inputDoc]);

  useEffect(() => {
    setInputDoc({
      ...inputDoc,
      tratamiento:tratamientos,
    })
  }, [tratamientos]);

  const handleChange = (e) => {
    setInputDoc({
      ...inputDoc,
      [e.target.name]: e.target.value
    })
  }
  
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(PostDocDDJJNuevo(inputDoc, userId, token));
    navigate('/adminpanel/' + userId);
  };
  



  return (
    <div className='p-16 flex flex-col gap-10'>
      <Link to={'/adminpanel/' + userId}>
      <button className='w-20 rounded p-2 bg-background_home text-white'>VOLVER</button>
      </Link>
    <form className='border w-auto p-6 flex flex-col gap-4'>
          <h1 className='text-xl font-bold'>Datos del/la profesional</h1>
          <textarea cols="30" rows="10" placeholder='Resumen Historia Clínica' name='historiaClinica' value={inputDoc.historiaClinica} onChange={handleChange} className='border'></textarea>
          <h1 className='font-bold'>Antecedentes personales</h1>
          
          <div className='flex flex-row gap-3'>
          <p>¿El/La paciente refiere durante la entrevista, arritmias o angor en actividad?</p>
          <select className='bg-white' name="arritmiaAngor" onChange={handleChange} defaultValue={"no"}>
            
            <option value="si">Si</option>
            <option value="no">No</option>
          </select>      
          </div>
          
          <div className='flex flex-col gap-4'>
          <div className='flex flex-row gap-3'>
          <p>¿El/La paciente refiere durante la entrevista, antecedentes de algún padecimiento en salud mental?¿Se encuentra actualmente en tratamiento?</p>
          <select className='bg-white' name="saludMental" onChange={handleChange} defaultValue={"no"}>
            <option value="si">Si</option>
            <option value="no">No</option>
          </select>      
          </div>
          <textarea name="saludMentalEspecificar" onChange={handleChange} className='border' placeholder='En caso de Si, especificar' cols="30" rows="10"></textarea>
          </div>

          <div className='flex flex-row gap-3'>
          <p>¿El/La paciente refiere alergia a algún componente de la planta?</p>
          <select className='bg-white' name="alergia" onChange={handleChange} defaultValue={"no"}>
            <option value="si">Si</option>
            <option value="no">No</option>
          </select>      
          </div>
          
          <div className='flex flex-row gap-3'>
          <p>¿El/La paciente refiere embarazo en curso o lactancia?</p>
          <select className='bg-white' name="embarazo" onChange={handleChange} defaultValue={"no"}>
            <option value="si">Si</option>
            <option value="no">No</option>
          </select>      
          </div>
         
          <div className='flex flex-row gap-3'>
          <p>¿El/La paciente refiere manejar maquinarias de alta precisión?</p>
          <select className='bg-white' name="maquinaria" onChange={handleChange} defaultValue={"no"}>
            <option value="si">Si</option>
            <option value="no">No</option>
          </select>      
          </div>

          <span className='text-slate-300'>Diagnostico: </span>
          <select name="diagnostico" className='border rounded p-2 text-xs' onChange={handleChange} defaultValue={"all"}>
            <option value="all" disabled>Selecciona</option>
               {
                  patologias.map((option, ind) => {
                     return (       
                      <option key={ind} value={inputDoc.value} /* className='bg-background_home text-white' */> {option.nombre} </option>                    
                      )
                  })
               }
              </select>
              {inputDoc.tratamiento?
                    <p className='border rounded p-2 text-xs'>{inputDoc.tratamiento}</p>:
                    <textarea type="text" placeholder='Los tratamientos propuesto consisten en ' className='border rounded p-2 text-xs' onChange={handleChange} />
                  }
          <div className='flex flex-col gap-2'>
              <span className='text-slate-400 '>Fecha del día:</span>
              <input type="date" placeholder='Fecha del día' value={inputDoc.fechaDelDia} name='fechaDelDia' className='border p-2 rounded' onChange={handleChange} />
          </div>
          
           <button onClick={handleSubmit} className='p-2 text-white bg-background_home'>ENVIAR</button>
          
        </form>
        </div>
  )
}

export default DdjjMedicoNuevo